<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}

.menu-dragbox .vs-list--item {
  background: #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
}

.menu-dragbox {
  height: 340px;
  overflow-y: scroll;
}

.vs-list--item {
  position: relative;
}
/*.vs-input-primary {
  position: absolute;
  left: 4px;
  top: 0;
}*/
.menu-editwrap span:first-child {
  display: inline-flex;
  height: 100%;
  background: transparent;
  margin-left: 10px;
  color: #cc8899;
  padding: 4px 14px;
  margin-top: 0;
  border-radius: 3px;
}
.menu-editwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <vs-tabs v-model="activeTab">
		  <vs-tab label="Booth">
		    <div class="tab-text">
		     <vs-table :data="pageData">
		        <template slot="thead">
		          <vs-th>Booth</vs-th>
		          <vs-th>Description</vs-th>
              <vs-th>Publish</vs-th>
		          <vs-th>Action</vs-th>
		        </template>

		        <template slot-scope="{ data }">
		          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
		            <vs-td :data="data[indextr].Name">{{
		              data[indextr].Name
		            }}</vs-td>
		            <vs-td>{{data[indextr].Description}}</vs-td>
                <vs-td>
                  <vs-switch v-model="data[indextr].IsPublished" @input="changeStatus(data[indextr].IsPublished, data[indextr].ID)">
                  </vs-switch>
                </vs-td>
		            <vs-td :data="data[indextr].ID">
		              <feather-icon
		                icon="EditIcon"
		                title="Edit"
		                svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
		                @click="getBoothMapDetail(data[indextr].ID)"
		              />
		              <feather-icon
		                icon="EyeIcon"
		                title="View"
		                svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
		              />
		            </vs-td>
		          </vs-tr>
		        </template>
		      </vs-table>
		    </div>
		  </vs-tab>  

		  <vs-tab label="Route" v-on:click="$router.push(`/event/rootmaps/${$route.params.mid}`)">
		    <div class="tab-text">
		      <span>Route</span>
		    </div>
		  </vs-tab>

		</vs-tabs>  

    </div>

    <div class="vx-card p-6 mt-3">
      <Jcrop
        v-if="mapImgSrc"
        :src="mapImgSrc"
        @update="sel = $event.sel"
        :options="options"
        :rect="fromPoints"
      />
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Left</label>
            <vs-input class="inputx w-full" readonly v-model="boothData.Left" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Top</label>
            <vs-input class="inputx w-full" readonly v-model="boothData.Top" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Right</label>
            <vs-input class="inputx w-full" readonly v-model="boothData.Right" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Bottom</label>
            <vs-input class="inputx w-full" readonly v-model="boothData.Bottom" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Width(W)</label>
            <vs-input class="inputx w-full" readonly v-model="boothData.Width" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label> Hight(H)</label>
            <vs-input class="inputx w-full" readonly v-model="boothData.Hight" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Total W</label>
            <vs-input class="inputx w-full" readonly :value="TotalWidth" />        
        </div>
        <div class="vx-col md:w-1/4 w-full mt-2">
            <label>Total H</label>
            <vs-input class="inputx w-full" readonly :value="TotalHeight" />        
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <label>
            Name
            <span class="rqrd">*</span>
          </label>
          <vs-input
            class="inputx w-full"
            name="Name"
            v-model="boothData.Name"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('Name')"
          >{{ errors.first('Name') }}</span>
        </div>
        <div class="vx-col md:w-6/12 w-full mt-2">
          <label>
            Description
          </label>
          <vs-input
            class="inputx w-full"
            name="Description"
            v-model="boothData.Description"
          />
        </div>
        <div class="flex justify-between items-center mt-2">
          <vs-button class="ml-0" @click="before_save">Save</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { Jcrop } from 'vue-jcrop';
// Store Module
import moduleFloorMapManagement from "@/store/floormap-management/moduleFloorMapManagement.js";

// Cell Renderer
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";

//console.log(db);

export default {
  components: {
    AgGridVue,
    Jcrop,
    // Cell Renderer
    CellRendererActions,
  },
  data() {
    return {   
      activeTab: 0, 
      searchQuery: "",  
      gridOptions: {},
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'ID',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          pinned: "left",
        },
        {
          headerName: "Booth",
          field: "Name",
          filter: true,
          width: 300,
          //pinned: "left",
        },                
        {
          headerName: 'Description',
          field: 'Venue',
          filter: true,
          //width: 125,
          cellClass: 'text-center'
        },       
        {
          headerName: "Actions",
          field: "transactions",
          //width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return { id: params.data.ID };
          },
          //pinned: "right",
        },
      ],
      TotalWidth: 0,
      TotalHeight: 0,
      mapImgSrc: null,
      options: {
        shade: true 
      },
      sel: {
        x:0,
        y:0 
      }, 
      bmapId: null,
      boothData: {  
        Left: 10,
        Top: 10,
        Right: 110,
        Bottom: 110,
        Width: 100,
        Hight: 100,
        Name: null,
        Description: null
      },
      fromPoints: [10,10,100,100],      
      // Cell Renderer Components
      components: {
        CellRendererActions,
      },
    };
  },
  watch: {
    sel(val){
      this.boothData.Left = val.x;
      this.boothData.Top = val.y;
      this.boothData.Right = val.x+val.w;
      this.boothData.Bottom = val.y+val.h;
      this.boothData.Width = val.w;
      this.boothData.Hight = val.h;
    }
  },
  computed: {
    pageData() {
      return this.$store.state.floorMapManagement.boothmaps.filter(item=> item.ParentID == this.$route.params.mid);
    },
    selData(){
      return {
        Left: this.sel.x,
        Top: this.sel.y,
        Right: this.sel.x+this.sel.w,
        Bottom: this.sel.y+this.sel.h,
        Width: this.sel.w,
        Hight: this.sel.h
      }
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 5;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    getFloorMapDetail(mapId){
      this.$store.dispatch("floorMapManagement/fetchFloorMap", mapId).then(res=>{
        if(res.status == 200){
          this.mapImgSrc = res.data.MapImage;
          this.TotalWidth = res.data.TotalWidth;
          this.TotalHeight = res.data.TotalHeight;
        }
      })
    },
    getBoothMapDetail(bmapId){
    	this.$vs.loading();
      this.$store.dispatch("floorMapManagement/fetchBoothMap", bmapId).then(res=>{
      	this.$vs.loading.close();
        if(res.status == 200){
          this.bmapId = bmapId;
          this.boothData = res.data;
          this.fromPoints = [res.data.Left,res.data.Top,res.data.Width,res.data.Hight];
        }else{
        	this.$vs.notify({
	            color: "warning",
	            position: "top-center",
	            //title: "Page",
	            text: "Unable to fetch data!",
	          });
        	this.reset_boothmapData();
        }
      })
    },
    before_save() {
  	  this.$validator.validateAll().then((result) => {
  	    if (result) {
  	      // if form have no errors
  	      this.save_changes();
  	    }
  	  });
  	},
  	save_changes() {
  	  /* eslint-disable */
  	  //if (!this.validateForm) return;

  	  this.$vs.loading();
  	  const Id = this.bmapId;
  	  let boothData = this.boothData;
  	  boothData.ParentID = this.$route.params.mid;
  	  boothData.EntityType = 1;
  	  if (Id) {
  	      this.$store
  	        .dispatch("floorMapManagement/updateBoothMap", {
  	          id: Id,
  	          data: boothData,
  	        })
  	        .then((res) => {
  	          this.$vs.notify({
  	            color: "success",
  	            position: "top-center",
  	            //title: "Page",
  	            text: "Data updated successfully.",
  	          });
  	          this.$vs.loading.close();
  	          this.reset_boothmapData();
  	          this.$store.dispatch("floorMapManagement/fetchBoothMaps");
  	        })
  	  } else {
  	      this.$store
  	        .dispatch("floorMapManagement/addBoothMap", { data: boothData })
  	        .then((res) => {
  	        	if (res.status == 200) {
  		          this.$vs.notify({
  		            color: "success",
  		            position: "top-center",
  		            //title: "Page",
  		            text: "Data added successfully.",
  		          });
  		          this.$vs.loading.close();
  	          
  	            this.reset_boothmapData();
  	            this.$store.dispatch("floorMapManagement/fetchBoothMaps");
  	          }
  	        })
  	  }
  	},
  	reset_boothmapData(){
  		this.bmapId = null;
  	    this.boothData = {  
  	        Left: 10,
  	        Top: 10,
  	        Right: 110,
  	        Bottom: 110,
  	        Width: 100,
  	        Hight: 100,
  	        Name: null,
  	        Description: null
  	    }
  	    this.fromPoints = [10,10,100,100];
  	},
    changeStatus(value, ID){
      this.$vs.loading();
      this.$store.dispatch("floorMapManagement/changeStatusBoothmap", {'IsPublished':value,'id':ID}).then(res=>{
        this.$vs.loading.close();
      })
    },
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    //this.gridApi.setDomLayout('normal');
    //this.gridApi.setRowData(ta(this.gridApi.paginationGetTotalPages()));
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    if(!this.$route.params.mid) 
      this.$router.push(`/event/floormaps`);
    if (!moduleFloorMapManagement.isRegistered) {
      this.$store.registerModule("floorMapManagement", moduleFloorMapManagement);
      moduleFloorMapManagement.isRegistered = true;
    }
    this.$store.dispatch("floorMapManagement/fetchBoothMaps").catch((err) => {
      console.error(err);
    });
    this.getFloorMapDetail(this.$route.params.mid);
    
  },
};
</script>